import React from 'react';
import './App.css';
import WeatherDashboard from './components/WeatherDashboard';

function App() {
  return (
    <div className="App">
      <WeatherDashboard />
    </div>
  );
}

export default App;